import { render } from "./AboutDescription.vue?vue&type=template&id=75814218&scoped=true"
const script = {}

import "./AboutDescription.vue?vue&type=style&index=0&id=75814218&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75814218"]])

export default __exports__